import user_actions, { user_action_keys } from "./user";
import token_actions, { token_action_keys } from "./token";
import app_actions, { app_action_keys } from "./app";
import account_actions, { account_action_keys } from "./account";
import layout_actions, { layout_action_keys } from "./layout";
import sidebar_actions, { sidebar_action_keys } from "./sidebar";

/** Package action keys. */
const action_keys = {
    user: user_action_keys,
    token: token_action_keys,
    app: app_action_keys,
    account: account_action_keys,
    layout: layout_action_keys,
    sidebar: sidebar_action_keys,
}

/**
 * Package actions.
 * @type {import("../types/actions").DefaultActions}
 */
const default_actions = { 
    ...user_actions,
    ...token_actions,
    ...app_actions,
    ...account_actions,
    ...layout_actions,
    ...sidebar_actions,
}

export { action_keys };

export default default_actions;